var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#407094;}\r\n\t.st1{fill:#2C4D66;}\r\n\t.st2{fill:#F7EFF0;}\r\n\t.st3{fill:#E0CB49;}\r\n\t.st4{fill:#F6E268;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Barrier") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,11h15c0.6,0,1,0.4,1,1v2H4V11z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    className: "st1",
    width: 1,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2,20h20v2H2V20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,19c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v1H2V19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,19c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v1h-5V19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3,12.5C3,11.7,3.7,11,4.5,11l0,0C5.3,11,6,11.7,6,12.5V18H3V12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18,12.5c0-0.8,0.7-1.5,1.5-1.5l0,0c0.8,0,1.5,0.7,1.5,1.5V18h-3V12.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 4.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 19.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.6,7L2,3.4V2h1.4L7,5.6V7H5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2,5.6L5.6,2H7v1.4L3.4,7H2V5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8,11h2l-1,3H7L8,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M12,11h2l-1,3h-2L12,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16,11h2l-1,3h-2L16,11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServico);
export default __webpack_public_path__ + "static/media/servico.57f527893f992e7ddd69cc6f8e4872df.svg";
export { ForwardRef as ReactComponent };